import { useQueryGet } from "@/typed-client/hooks/use-query-get"

export function useHasOverdueReminderForCurrentUser() {
  return useQueryGet("/api/Reminder/HasOverdueReminderForCurrentUser", null)
}
